import AutocompleteController from './autocomplete_controller';

export default class extends AutocompleteController {
  static targets = AutocompleteController.targets

  static classes = AutocompleteController.classes

  static values = {
    ...AutocompleteController.values,
    options: Array,
  }

  onInputChange = () => {
    this.element.removeAttribute('value');
    if (this.hasHiddenTarget) this.hiddenTarget.value = '';

    const query = this.inputTarget.value.trim();
    if (query && query.length >= this.minLengthValue) {
      this.replaceOptions(this.searchOptions(query));
    } else {
      this.hideAndRemoveOptions();
    }
  }

  searchOptions (query) {
    const needle = query.toLowerCase();
    return this.optionsValue.filter(option =>
      String(option).toLowerCase().includes(needle),
    );
  }

  replaceOptions (options) {
    this.resultsTarget.innerHTML = null;

    options.forEach((option) => {
      const item = document.createElement('li');
      item.classList.add('form__input-list__group-item');
      item.setAttribute('role', 'option');
      item.textContent = String(option);
      this.resultsTarget.appendChild(item);
    });

    this.identifyOptions();
    if (this.options.length !== 0) {
      this.open();
    } else {
      this.close();
    }
  }
}
